import React, { createContext, useContext, useEffect, useState } from "react";
import { t as tr } from "@/lib/translations";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("sjds_lang") || "es");
  useEffect(() => { localStorage.setItem("sjds_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (k) => tr(lang, k);
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
